<template>
    <QrButton danger :loading="loading" @click="modalOpen = true">
        {{ trans('button.delete') }}
    </QrButton>

    <QrConfirm
        :open="modalOpen"
        @close="modalOpen = false"
        :title="trans('content.delete-qr-code')"
        :body="trans('content.are-you-sure-you-want-do-delete-this-code')"
        :button-text="trans('button.delete')"
        @confirm="confirmed"
    />
</template>

<script setup>
import { ref } from "vue";
import { trans } from "@/libs/helper.js";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import QrConfirm from "@/components/application-ui/dialogs/QrConfirm.vue";
import { storeToRefs } from "pinia";
import { useStatesStore } from "@/store/states.js";
import { useQrCodesStore } from "@/store/qrCodes.js";

const statesStore = useStatesStore();
const qrCodesStore = useQrCodesStore();
const { loading } = storeToRefs(statesStore);
const modalOpen = ref(false);
const props = defineProps({
    qrCode: Object
});

const confirmed = async () => {
    await qrCodesStore.remove(props.qrCode.id)
    modalOpen.value = false
};
</script>
